// extracted by mini-css-extract-plugin
export var container = "_9v-0";
export var error = "_9v-9";
export var label = "_9v-5";
export var light = "_9v-6";
export var md = "_9v-3";
export var sm = "_9v-2";
export var thin = "_9v-8";
export var thinBold = "_9v-7";
export var vertical = "_9v-4";
export var xs = "_9v-1";